import PropTypes from 'prop-types'
import { memo, useMemo } from 'react'
import Tooltip from 'components/interface/Tooltip/Tooltip'
import classNames from 'lib/util/classNames'
import styles from './Indicator.module.scss'

/**
 * The `Indicator`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function Indicator (props) {
  const { className, index, isSelected, ...rest } = props
  const classNameOutput = useMemo(
    () =>
      classNames([className, styles.container, isSelected && styles.selected]),
    [className, isSelected]
  )

  return (
    <Tooltip.Target
      Tag="button"
      tooltipContent={
        <Tooltip size="small">
          <Tooltip.Header>View Slide {index + 1}</Tooltip.Header>
        </Tooltip>
      }
      className={classNameOutput}
      {...rest}
    />
  )
}

/** @type {object} */
Indicator.propTypes = {
  index: PropTypes.number,
  className: PropTypes.string,
  isSelected: PropTypes.bool
}

/** @type {object} */
Indicator.defaultProps = {
  index: 0,
  className: '',
  isSelected: false
}

// Memoize
export default memo(Indicator)
